import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-nav-filter',
  templateUrl: './nav-filter.component.html',
  styleUrls: ['./nav-filter.component.scss']
})
export class NavFilterComponent implements OnInit {

  iconPrefix = 'fal';

  constructor() { }

  ngOnInit(): void {
  }

}
